import { NgModule } from '@angular/core';
import { FieldValueFormaterDirective } from './directives/field-value-formater.directive';
import { DynamicScriptLoaderService } from './services/dynamic-script-loader.service';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { ZcDailogModule } from './zc-dialog/zc-dialog.module';
import { ZcLoaderModule } from './zc-loader/zc-loader';
import { FileHttpDownloadDirective } from './directives/file-http-download.directive';
@NgModule({
    imports: [
        NgbModalModule.forRoot(),
        ZcDailogModule,
        ZcLoaderModule
    ],
    providers: [DynamicScriptLoaderService],
    declarations: [FieldValueFormaterDirective, FileHttpDownloadDirective],
    exports: [ZcLoaderModule, FieldValueFormaterDirective, ZcDailogModule]
})
export class ZcWidgetCoreCommonModule { }
